import { takeEvery } from 'redux-saga/effects';
import { AT_SEND_HTTP_REQUEST, sendHttpRequestFlow } from './api/WebData';
import { Command } from './MessageFlow/actions';
import { importMessageFlowFileFlow } from './MessageFlow/sagas';
import { History } from 'history';

export default function* rootSaga(history: History) {
    yield [
      takeEvery(AT_SEND_HTTP_REQUEST, sendHttpRequestFlow),
      takeEvery(Command.CMD_IMPORT_MESSAGE_FLOW_FILE, importMessageFlowFileFlow),
    ];
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/saga.ts